import React, { PureComponent } from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { withStyles } from 'tss-react/mui';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import blue from '@mui/material/colors/blue';
import { compose } from 'redux';

import notifSystem from '../notifSystem';
import api from '../api';
import withRouter from '../components/Hoc/withRouter';
import withMediaQuery from '../components/Hoc/WithMediaQuery';
import logo from '../../public/lesbonsartisansdef.png';
import home from '../../public/home.jpg';
import CustomPasswordInput from './CustomInputs/CustomPasswordInput';

const styles = {
  main: {
    backgroundColor: 'white',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    zIndex: 300,
    transition: 'opacity 0.5s',
  },
  center: {
    margin: 'auto',
  },
  imgX: {
    width: '50%',
    height: '100%',
    'background-image': `url("${home}")`,
    'background-size': 'cover',
    'background-repeat': 'non-repeat',
    'background-position': 'right',
  },
  login: {
    'margin-top': '30%',
    padding: 20,
    textAlign: 'right',
  },
  img: {
    position: 'fixed',
    maxWidth: 300,
    top: 25,
    left: 50,
  },
  marginBottom: {
    marginBottom: 20,
    display: 'flex',
    flexDirection: 'row',
    gap: '2.5%'
  },
  displayInput: {
    width: '48.75%',
  },
  marginTopLeft: {
    float: 'left',
  },
};

const initState = {
  password: '',
  verify: '',
  error: '',
  isValid: false
};

const theme = createTheme({
  palette: {
    primary: blue,
  },
});

class ResetPassword extends PureComponent {
  constructor() {
    super();
    this.state = initState;
  }

  componentDidMount() {
    const { params } = this.props;
    const token = params.token;
    this.setState({ token });
  }

  confirmPasswordReset = async (password, verify, token, isValid) => {
    if (!password) {
      notifSystem.error('Erreur!', 'Mot de passe non saisi');
      return false;
    }
    if (password !== verify) {
      notifSystem.error('Erreur!', 'Les mots de passe sont différents');
      return false;
    }
    if (!isValid) {
      notifSystem.error('Erreur!',
        'Le mot de passe n\'est pas assez puissant');
      return false;
    }
    if (!token) {
      notifSystem.error('Erreur', 'Token de réinitialisation manquant');
      return false;
    }
    try {
      const res = await api.custom('confirmPasswordReset')
        .post({
          password,
          token
        });
      if (res.statusCode() === 200) {
        notifSystem.success('Succès', 'Mot de passe modifié');
        notifSystem.success('Vous allez être redirigé',
          'Bienvenue chez Les Bons Artisans');
        setTimeout(() => (window.location.assign('/')), 3000);
      }
    } catch (error) {
      notifSystem.error(error.name, error.response ?
        error.response.data : error.message);
    }
    return false;
  };

  changePassword = () => {
    const { password, verify, token, isValid } = this.state;
    if (this.confirmPasswordReset(password, verify, token, isValid)) {
      this.setState(initState);
    }
  };

  render() {
    const classes = this.props.classes;
    return (
      <ThemeProvider theme={theme}>
        <div className={classes.main}>
          <Grid className={classes.center} item xs={12} md={12} lg={5}>
            <Grid className={classes.login}>
              <img
                src={logo}
                alt="logo"
                className={classes.img}
                width={'100%'}
              />
              <div className={classes.marginBottom}>
                <CustomPasswordInput
                  label="Nouveau mot de passe"
                  showSecurityLevelDescription
                  showSecurityLevelBar
                  value={this.state.password}
                  className={classes.displayInput}
                  onChange={
                    ({ value, isValid }) => this.setState({
                      password: value,
                      isValid })
                  }
                />
                <CustomPasswordInput
                  label="Vérifier le mot de passe"
                  value={this.state.verify}
                  className={classes.displayInput}
                  onChange={({ value }) => this.setState({ verify: value })}
                />
              </div>
              <Button
                variant="contained"
                color="primary"
                className={classes.marginTop}
                onClick={this.changePassword}
              >
                Valider mon mot de passe
              </Button>
            </Grid>
          </Grid>
          {this.props.isUp.md &&
            <div src={home} alt="logo" className={classes.imgX} />
          }
        </div>
      </ThemeProvider>
    );
  }
}

export default compose(
  withRouter,
  withMediaQuery()
)(withStyles(ResetPassword, styles));
